/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { DeviceModel } from '../../../../core/device';
import { DateTime } from '../../../../core/utils';

import './AiringInfo.scss';

interface AiringInfoProps {
    startTime: number;
    endTime: number;
    videoResolution?: string;
    channelNumber?: string;
    callSign?: string;
}
const AiringInfo = ({
    startTime,
    endTime,
    channelNumber,
    callSign,
    videoResolution,
}: AiringInfoProps) => {
    return (
        <>
            <div className="preview-airing-info" data-testid="preview-airing-info">
                <span>
                    {DateTime.createDayDateTimeRange({
                        startTime,
                        endTime,
                        lang: DeviceModel.getTVProperties().getLang(),
                    })}
                </span>
            </div>
            <div
                className="content-airing-info program-preview-channel-info"
                data-testid="program-preview-channel-info"
            >
                <span>{channelNumber}</span>
                {videoResolution && (
                    <div className={`preview-stream-type-icon ${videoResolution}`}></div>
                )}
                <span>{callSign}</span>
            </div>
        </>
    );
};

export default AiringInfo;
